export default __webpack_public_path__ + "img/img2.f2860a6e.png";